import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "cy-history-row"
};
const _hoisted_2 = ["title"];
import { toRefs } from 'vue';
import Chip from '@/components/Common/Chip.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'HistoryRow',
    props: {
        item: { default: () => ({}) },
        headers: { default: () => [] }
    },
    setup(__props) {
        const props = __props;
        const { item, headers } = toRefs(props);
        return (_ctx, _cache) => {
            return (_unref(item))
                ? (_openBlock(), _createElementBlock("tr", _hoisted_1, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(headers), (header, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                            _createCommentVNode(" 처리과정 Chip "),
                            (header.value === 'processStatusChip')
                                ? (_openBlock(), _createElementBlock("td", {
                                    key: `chip-${header.value}-${index}`,
                                    class: "ta-c"
                                }, [
                                    _createVNode(Chip, {
                                        text: _unref(item)[header.value].text,
                                        "brg-chip-color": _unref(item)[header.value].color
                                    }, null, 8 /* PROPS */, ["text", "brg-chip-color"])
                                ]))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createCommentVNode(" 설정대상 "),
                                    _createCommentVNode(" 설정유형 "),
                                    _createCommentVNode(" 내용 "),
                                    _createCommentVNode(" 처리자 "),
                                    _createCommentVNode(" 처리일시 "),
                                    (_openBlock(), _createElementBlock("td", {
                                        key: `text-${header.value}-${index}`,
                                        title: _unref(item)[header.value],
                                        class: "ta-c"
                                    }, _toDisplayString(_unref(item)[header.value]), 9 /* TEXT, PROPS */, _hoisted_2))
                                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                        ], 64 /* STABLE_FRAGMENT */));
                    }), 256 /* UNKEYED_FRAGMENT */))
                ]))
                : _createCommentVNode("v-if", true);
        };
    }
});
